import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { SlotsService } from './slots.service';
import { SlotDataService } from './slots-data.service';
import * as moment from 'moment-timezone';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LoaderService } from '../shared/loader-spinner/index';
import { CssVarsService } from '../shared/services/cssVarsService.service';
import { UserInfoService } from '../shared/services/security.service';
import { Subscription } from 'rxjs';
import { TranslateService } from "@ngx-translate/core";
import { SharedService } from '../shared/services/shared.service';
import { ConfirmationTemplateBodyComponent } from './confimation-sideBar/confirmation-sidebar.component';
import { Config } from '../../config';
import { languageEnum } from '../shared/enum-files/languageEnum';

@Component({
  selector: 'app-slots',
  templateUrl: './slots.component.html',
  styleUrls: ['./slots.component.css']
})
export class SlotsComponent implements OnInit, OnDestroy {
  @ViewChild("confirmTab", { read: ViewContainerRef })
  confirmTab: ViewContainerRef;
  public appointmentDetail;
  public page: number = 1;
  public appointmentCode;
  public currentPath;
  isRecruiter : boolean = false;
  public leadUserInfo;
  public timezoneSubscription;
  public bookAppointmentSubscription : Subscription;
  public companyName: string;
  public uiFooter;
   confirmationData;
   selectedDate;
  roundOffDate;
  currentLang:string = 'nl-NL';
  public availableTimeZonesList:any = this.slotDataService.availableTimeZonesList;
  public selectedTimeZone:string = "";
  private config = new Config();
  public tagCode;
  public isExternal;
  public externalStyle;
  public isMobileView:boolean=false;
  slotsData:any = {};
  public isAppointmentDetailsAvaiable: boolean = false;
  public isErrorInFlow: boolean = false;
  public submissionErrorMessage: string = "";
  public savedAppointmentSlot: any = {};
  
  constructor(private slotsService: SlotsService,
    private translate: TranslateService,
    public slotDataService: SlotDataService,
    private sharedService : SharedService,
    private route: ActivatedRoute,
    private loaderService: LoaderService,
    private router: Router,
    private activatedRoute : ActivatedRoute,
    private _crf: ComponentFactoryResolver,
    private cssVarsService: CssVarsService,
    private userInfoService : UserInfoService
  ) {}

  /**
   * 
   */

  ngOnInit() {
    let isRescheduleUrl:boolean = this.router.url && this.router.url.split("?")[0] && this.router.url.split("?")[0].toLowerCase().includes("reschedule") ? true : false;
    console.log(isRescheduleUrl, "ht test 1");
    if(isRescheduleUrl){
      this.getRescheduleSlotsData();
    }
    else{
      this.getSlotsData();
    }
    if(window.outerWidth < 768){
      this.isMobileView=true;
    }else{
      this.isMobileView=false;
    }
    this.activatedRoute.snapshot.queryParams.type == "1" ? this.isRecruiter = true : this.isRecruiter = false;
    this.currentPath = this.route.snapshot.url.join('/');

    // var slotsData = this.route.snapshot.data['slotsData'] ? this.route.snapshot.data['slotsData'] : {};

    this.sharedService.isExternal = this.route.snapshot.queryParams["isExternal"];
    this.sharedService.externalStyle = this.route.snapshot.queryParams["isExternalStyle"];
    this.sharedService.externalLang = this.route.snapshot.queryParams["lang"];
    this.isExternal = this.sharedService.isExternal;
    this.externalStyle = this.sharedService.externalStyle;

    this.cssVarsService.setVariables({
      '--external-color': "#000"
    }); 

    
      this.getTimeZoneList();
  }

  setSlotsData(){
    if(this.externalStyle){

      this.externalStyle = JSON.parse(this.externalStyle);
      this.cssVarsService.setVariables({
        '--external-color': this.externalStyle.quiz_BackgroundColorofSelectedAnswer
      }); 
      window.parent.postMessage({
        'message': 'loader',
      }, "*"); 
    }else{
      this.cssVarsService.setVariables({
        '--external-color': this.slotsData.SecondaryBrandingColor
      }); 
    }
    if(this.sharedService.isExternal){
      if(this.sharedService.externalLang == languageEnum.Dutch){
        this.currentLang = "nl-NL";
      }else if(this.sharedService.externalLang == languageEnum.English){
        this.currentLang = "en-US";
      }else if(this.sharedService.externalLang == languageEnum.Polish){
        this.currentLang = "pl-PL";
      }else{
        this.currentLang = "de-DE";
      }
    }else{
      if(this.slotsData.Language){
        if(this.slotsData.Language == languageEnum.Dutch){
          this.currentLang = "nl-NL";
        }else if(this.slotsData.Language == languageEnum.English){
          this.currentLang = "en-US";
        }else if(this.slotsData.Language == languageEnum.Polish){
          this.currentLang = "pl-PL";
        }else{
          this.currentLang = "de-DE";
        }
      }
    }
    if(this.slotsData && this.slotsData.CalendarTimeZoneId){
      this.selectedTimeZone = this.slotsData.CalendarTimeZoneId;
      this.slotDataService.timezone = this.selectedTimeZone;
    }
    this.onlangChange(this.currentLang);

    this.uiFooter = this.slotsData.UiFooter;
    this.slotDataService.uiFooter = this.slotsData.UiFooter;
    this.slotDataService.allowRescheduling = this.slotsData.AllowRescheduling;
    this.slotDataService.allowCancellation = this.slotsData.AllowCancellation;
    this.cssVarsService.setVariables({
      '--primary-color': this.slotsData.PrimaryBrandingColor,
      '--secondary-color': this.slotsData.SecondaryBrandingColor
    });
    this.slotDataService.setLogoUrlAndCompanyName(this.slotsData.LogoUrl, this.slotsData.CompanyName);
    this.companyName = this.slotsData.CompanyName;
    this.appointmentCode = this.slotDataService.getAppointmentCode();
    this.appointmentDetail = this.slotDataService.getAppointMentDetail();
    if(this.appointmentDetail && Object.keys(this.appointmentDetail).length > 0){
      this.isAppointmentDetailsAvaiable = true;
    }
    if(this.appointmentDetail.BookingSlotsShiftwise.length > 0){
      this.selectedDate = this.appointmentDetail.BookingSlotsShiftwise[0].Date;
    }
    this.appointmentDetail.BookingSlotsShiftwise.forEach(element =>{
      if(element.IsSelectedCalendar){
        this.selectedDate = element.Date;
      }
    })
    if(this.appointmentDetail.BookingSlots && this.appointmentDetail.BookingSlots.length == 0 && this.appointmentDetail.BookingSlotsShiftwise && this.appointmentDetail.BookingSlotsShiftwise.length == 0){
      window.parent.postMessage({
        'message': 'success',
        'isSlotBook' : true
      }, "*");
    }
    this.addFormatedDate(this.appointmentDetail);
    this.leadUserInfo = this.slotDataService.getLeadUserInfo();
    
    if (this.slotsData.IsBooked && !this.slotDataService.hasReschedule) {
      let queryParamsToApply:any = {};
          queryParamsToApply["AppointmentCode"] = this.slotDataService.getAppointmentCode();
          queryParamsToApply["type"] =  this.isRecruiter ? 1 : 2;
          
          if(this.sharedService.isExternal && (this.sharedService.isExternal === true || this.sharedService.isExternal === "true")){
            queryParamsToApply["isExternal"] =  this.sharedService.isExternal;
            queryParamsToApply["lang"] =  this.sharedService.externalLang;
            queryParamsToApply["isExternalStyle"] =  this.sharedService.externalStyle;
          }
      this.router.navigate(['slots/confirmed'],{ queryParams: queryParamsToApply });
    }

    this.timezoneSubscription = this.slotsService.isTimezoneChange()
      .subscribe((timezonechanged)=>{
        this.getAppointmentSlots('zonechanged')
      });
      this.bookAppointmentSubscription = this.slotDataService.bookAppointment.subscribe((data)=>{
        this.confirmationData = undefined;
        this.selectedDate = {};
        if ('bookingTime' in data){
          this.confirmationData = data;
        } else{
          this.selectedDate = data.bookingDate;
        }
        this.savedAppointmentSlot = this.slotDataService.savedAppointmentSlot || {};
      })
      this.tagCode = this.slotsData.TagCode;
      this.setDataLayer('jr_Event_Calendar_View');
  }

  getTimeZoneList(){
    this.availableTimeZonesList = [];

    this.slotsService.getTimeZoneList(true).subscribe((data:any) => {
      if(data && data.length > 0){
        data.map((currObj:any,index:number,list:any) => {
          if((index+1) < list.length){
            this.availableTimeZonesList.push({"label":currObj.DisplayName,"value":currObj.Id});
          }
          else{
            this.availableTimeZonesList = [...this.availableTimeZonesList, {"label":currObj.DisplayName,"value":currObj.Id}];
          }
        });
      }
      
      this.slotDataService.availableTimeZonesList = this.availableTimeZonesList;
    });
  }

  setDataLayer(category){
    window['dataLayer'] = [];
        window['dataLayer'].push({
        'Event': 'JobrockEvent',
        'jrCategory': category,
        'jrTags': this.tagCode ? this.tagCode : ''
        });
  }

  onTimeChange(){
    this.slotDataService.timezone = this.selectedTimeZone;
    this.getAppointmentSlots('zonechanged');
  }
isTrue = true;
  addFormatedDate(data) {
    
    data.BookingSlotsShiftwise.forEach((item) => {
      var m = moment(item.Date, "YYYY-MM-DDTh:mm:ssZ").locale(this.currentLang.split(",")[0]);
      item['formattedDay'] = m.format();
      item['formattedDate'] = m.format();
    })
  }

  
  /**
   * Get Appointment Slots
   * @param type : prev/next
   */
  getAppointmentSlots(type) {
    
    if (type == 'prev' && this.page == 1) {
      return;
    }
    else if (type == 'prev' && this.page > 1) {
      this.page -= 1;
    }else if(type == 'zonechanged'){
      
    }
    else {
      this.page += 1;
    }
    if (this.currentPath == 'slots') {
      this.loaderService.show()
      this.slotsService.getAppointmentSlots(this.page, this.appointmentCode,this.isRecruiter ? 1 : 2,this.selectedTimeZone, true)
        .subscribe((data) => {
          if(data.Language){
            if(data.Language == languageEnum.English){
              this.currentLang = 'en-US';
            }else if(data.Language == languageEnum.Polish){
              this.currentLang = "pl-PL";
            }else if(data.Language == languageEnum.German){
              this.currentLang = "de-DE";
            }
          }
          this.onlangChange(this.currentLang);
          this.uiFooter = data.UiFooter;
          this.cssVarsService.setVariables({
            '--primary-color': data.PrimaryBrandingColor,
            '--secondary-color': data.SecondaryBrandingColor
          });
          this.slotDataService.setLogoUrlAndCompanyName(data.LogoUrl, data.CompanyName);
          this.companyName = data.CompanyName;
          this.loaderService.hide()
          this.addFormatedDate(data);
          this.slotDataService.setAppointMentDetail(data);
          this.appointmentDetail = data;
          if(data.BookingSlots && data.BookingSlots.length == 0 && data.BookingSlotsShiftwise && data.BookingSlotsShiftwise.length == 0){
            window.parent.postMessage({
              'message': 'success',
              'isSlotBook' : true
            }, "*");
          }
        }, (error) => {
          this.loaderService.hide()
          console.log(error);
        })
    }
    else if (this.currentPath == 'slots/reschedule') {
      this.loaderService.show()
      this.slotsService.rescheduleAppointment(this.page, this.appointmentCode,this.isRecruiter? 1 : 2,this.selectedTimeZone, true)
        .subscribe((data) => {
          if(data.Language){
            if(data.Language == languageEnum.English){
              this.currentLang = 'en-US';
            }else if(data.Language == languageEnum.Polish){
              this.currentLang = "pl-PL";
            }else if(data.Language == languageEnum.German){
              this.currentLang = "de-DE";
            }
          }
          this.onlangChange(this.currentLang);
          this.loaderService.hide()
          this.addFormatedDate(data);
          this.slotDataService.setAppointMentDetail(data);
          this.appointmentDetail = data;
        }, (error) => {
          this.loaderService.hide()
          console.log(error);
        })
    }

  }

  onlangChange(ln) {
    this.translate.use(ln);
    if(!this.sharedService.isExternal){
      localStorage.setItem('language', ln);
      localStorage.setItem('language-slots', ln);
    }
    this.slotsService.setLanguage(ln)
  }


  public onBookAppointment(time,date) {
    this.setDataLayer('jr_Event_Booked');
    let tempTime:string = "";
    if(this.isRecruiter){
      // tempTime = time;
      // time = moment(date.split('T')[0] + " " + tempTime).subtract(moment.tz(date.split('T')[0] + " " + tempTime, this.selectedTimeZone).utcOffset(), 'minutes').format("HH:mm");

    var SectionRef = this._crf.resolveComponentFactory(
      ConfirmationTemplateBodyComponent
    );
      this.confirmTab.clear();
      var confirmComponentRef = this.confirmTab.createComponent(SectionRef);
      confirmComponentRef.instance.appointmentdate = date;
      confirmComponentRef.instance.appointmenttime = time;
    }else{

      // tempTime = this.confirmationData.bookingTime;
      // this.confirmationData.bookingTime = moment(this.confirmationData.bookingDate.split('T')[0] + " " + tempTime).subtract(moment.tz(date.split('T')[0] + " " + tempTime, this.selectedTimeZone).utcOffset(), 'minutes').format("HH:mm");
      // tempTime = this.confirmationData.endTime;
      // this.confirmationData.endTime = moment(this.confirmationData.bookingDate.split('T')[0] + " " + tempTime).subtract(moment.tz(date.split('T')[0] + " " + tempTime, this.selectedTimeZone).utcOffset(), 'minutes').format("HH:mm");

    this.loaderService.show();
    this.slotsService.bookAppointment(this.confirmationData, true).subscribe(
      data => {
        this.loaderService.hide();
        this.sharedService.getTranslatedNotification(10);

        this.slotDataService.allowCancellation = data.AllowCancellation;
        this.slotDataService.allowRescheduling = data.AllowRescheduling;

        let queryParamsToApply:any = {};
          queryParamsToApply["AppointmentCode"] = this.slotDataService.getAppointmentCode();
          queryParamsToApply["type"] =  this.isRecruiter ? 1 : 2;
          
          if(this.sharedService.isExternal && (this.sharedService.isExternal === true || this.sharedService.isExternal === "true")){
            queryParamsToApply["isExternal"] =  this.sharedService.isExternal;
            queryParamsToApply["lang"] =  this.sharedService.externalLang;
            queryParamsToApply["isExternalStyle"] =  this.sharedService.externalStyle;
          }
        
        this.router.navigate(["slots/confirmed"], {
          queryParams: queryParamsToApply
        });
          window.parent.postMessage({
            'message': 'success',
            'isSlotBook' : true
          }, "*");
      },
      (error:any) => {
        this.loaderService.hide();
        const errorMessage = error.json();
        //this.sharedService.getTranslatedNotification(25);
        this.isErrorInFlow = true;
        if(errorMessage && errorMessage.message){
          this.submissionErrorMessage = errorMessage.message;
        }
        else{
          this.submissionErrorMessage = "";
        }
        console.log(error);
      }
    );
    }
  }

  getSlotsData(){
    this.loaderService.show();
    let appointmentCode;
        appointmentCode = this.activatedRoute.snapshot.queryParams.AppointmentCode;
        let user;
        if('type' in this.activatedRoute.snapshot.queryParams){
          this.activatedRoute.snapshot.queryParams.type == '1' ? user = 1 : user = 2;
        }else{
            user = 2;   
        }
        this.slotDataService.setAppointmentCode(appointmentCode);
        this.slotsService.getAppointmentSlots(1, appointmentCode,user,"",true)
        .subscribe(
          data => {
            this.slotsData = data;
            this.setSlotsData();
            this.loaderService.hide();
          },
          error => {
            this.router.navigate(['error']);
            this.sharedService.setErrorMessage({ status: error.status, message: error.json().message })
          }
        );
  }

  getRescheduleSlotsData(){
    this.loaderService.show();
    let appointmentCode;
        appointmentCode = this.activatedRoute.snapshot.queryParams.AppointmentCode;
        let user;
        this.activatedRoute.snapshot.queryParams.type == '1' ? user = 1 : user = 2
        this.slotDataService.setAppointmentCode(appointmentCode);
        this.slotsService.rescheduleAppointment(1, appointmentCode,user,this.slotDataService.timezone,true)
        .subscribe(
          data => {
            this.slotsData = data;
            this.setSlotsData();
            this.loaderService.hide();
          },
          error => {
            this.router.navigate(['error']);
            this.sharedService.setErrorMessage({ status: error.status, message: error.json().message })
          }
        );
  }

 
  ngOnDestroy() {
    if(this.timezoneSubscription){
      this.timezoneSubscription.unsubscribe();
    }
    
    if(this.bookAppointmentSubscription){
      this.bookAppointmentSubscription.unsubscribe();
    }
  }

  chooseAnotherSlot(){
    let queryParamsToApply: any = {};
    queryParamsToApply["AppointmentCode"] = this.slotDataService.getAppointmentCode();
    queryParamsToApply["type"] = this.isRecruiter ? 1 : 2;
    this.router.navigate(['slots/reschedule'],{ queryParams: queryParamsToApply });
  }
}


// WEBPACK FOOTER //
// ./src/app/slots/slots.component.ts